var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.42 4.62A1.019 1.019 0 0 0 21.5 4h-18c-.13 0-.26.03-.38.08-.25.1-.44.29-.54.54-.05.12-.08.25-.08.38v14c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V5c0-.13-.03-.26-.08-.38Zm-9.92 7.97L5.91 6h13.17l-6.59 6.59h.01ZM4.5 18V7.41l7.29 7.29c.2.2.45.29.71.29.26 0 .51-.1.71-.29l7.29-7.29V18h-16Z"
  })));
};
export default SvgMail;